module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921051149_T.213a9a82.jpg";